'use strict';

/**
 * @ngdoc directive
 * @name izzyposWebApp.directive:adminPosHeader
 * @description
 * # adminPosHeader
 */
(function () {
    'use strict';
    angular.module('myApp')
        .directive('credentialAlerts', credentialAlerts);

    function credentialAlerts() {
        var directiveObj = {};
        directiveObj.bindToController = true;
        directiveObj.controller = CredentialCtrl;
        directiveObj.controllerAs = 'credentialCtrl';
        directiveObj.templateUrl = 'js/scripts/directives/credential-alerts/credential-alerts.html';
        directiveObj.restrict = 'E';
        directiveObj.replace = true;
        return directiveObj;
    }

    function CredentialCtrl($scope, apiService, $localStorage, $state, $sessionStorage, userService) {

        var credentialCtrl = this;
        credentialCtrl.loading = false;
        credentialCtrl.nurseNotificationsCount = 0;
        credentialCtrl.getNotifications = getNotifications;
        credentialCtrl.removeNotification = removeNotification;
        credentialCtrl.redirectToBriefcase = redirectToBriefcase;
        credentialCtrl.notifications = [];

        if ($localStorage['token']) {
            credentialCtrl.getNotifications('CRED_ALERTS');
        }

        /*for redirect to licence tab from dashboard */
        function redirectToBriefcase() {
            $state.go('dashboard.license');
        }

        function getNotifications(notificationType) {
            credentialCtrl.loading = true;
            userService.listNotifications($localStorage['token'], { notificationType })
                .then((response) => {
                    credentialCtrl.loading = false;
                    if (response) {
                        credentialCtrl.notifications = response.list;
                        credentialCtrl.nurseNotificationsCount = response.count;
                    }
                })
                .catch(() => credentialCtrl.loading = false)
                .finally(() => $scope.$apply());
        }

        function removeNotification(index) {
            credentialCtrl.notifications.splice(index, 1);
        }

        $scope.$on('newNotification', function (event, args) {
            credentialCtrl.getNotifications('CRED_ALERTS');
        });
    }

})();


